<template>
  <fragment>
    <v-row>
      <v-col cols="6">
        <BaseSelect
          required
          tabindex="2"
          label="Categoria"
          item-text="descricao"
          item-value="idcategoria"
          placeholder="Selecione uma categoria"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.categorias_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.categoria"
        />
      </v-col>
      <v-col>
        <BaseMoneyField
          required
          tabindex="3"
          label="Preço"
          persistentHint
          hint="Insira aqui a opção de menor valor do produto."
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.preco"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseSelect
          required
          tabindex="1"
          label="Status"
          item-text="value"
          item-value="key"
          placeholder="Selecione o status do produto"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.status_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.status"
        />
      </v-col>
      <v-col cols="6">
        <BaseTextField
          required
          label="URL do IFrame"
          placeholder="Insira a url do iframe"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.url_iframe"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseTextField
          label="Local do evento"
          placeholder="Insira o local do evento"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.endereco"
        />
      </v-col>
      <v-col cols="6">
        <BaseAutocomplete
          :items="$config.paises.result"
          placeholder="Selecione o país"
          label="País"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.pais"
          :loading="$config.loading_paises"
          item-text="dsc_lang"
          item-value="iso_full"
          needSelection
          :filter="search"
        >
          <template v-slot:selection="{ item }">
            <template v-if="item ? (paises = item) : null">
              {{ item.dsc_lang }}
            </template>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content v-if="item">
              <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
            </v-list-item-content>
          </template>
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseAutocomplete
          :items="$config.estados.result"
          placeholder="Selecione o estado"
          label="Estado"
          needSelection
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.estado"
          :loading="$config.loading_estados"
          item-text="dsc_lang"
          item-value="dsc_lang"
          :filter="search"
        >
          <template v-slot:selection="{ item }">
            <template v-if="item ? (estados = item) : null">
              {{ item.dsc_lang }}
            </template>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content v-if="item">
              <v-list-item-title v-text="item.dsc_lang"></v-list-item-title>
            </v-list-item-content>
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="6">
        <BaseAutocomplete
          label="Cidade"
          item-text="dsc_lang"
          item-value="dsc_lang"
          placeholder="Selecione a cidade"
          :loading="$config.loading_cidades"
          :items="$config.cidades.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.cidade"
        >
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-checkbox
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.destaque"
          label="Produto em destaque"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
          hide-details
        >
        </v-checkbox>
      </v-col>
    </v-row>
  </fragment>
</template>
<script>
import mixins from "@/mixins";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";

const { products, formRules } = mixins;
export default {
  name: "IFrameProduct",
  mixins: [products, formRules],
  components: {
    BaseSelect,
    BaseMoneyField,
    BaseTextField,
    BaseAutocomplete,
  },
  data: () => ({
    paises: [],
    estados: [],
    cidades: [],
  }),
  methods: {
    replaceSpecialChars(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[èèêë]/, "e");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str
        .toString()
        .normalize("NFD")
        .replace(/[^a-zA-Zs]/g, "");
      str = str.replace(" ", "-");

      return str;
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc_lang.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  watch: {
    paises(e) {
      this.$config.getEstados(e.id);
    },
    estados(e) {
      this.$config.getCidades(e.id);
    },
  },
  mounted() {
    this.$config.getPaises();
  },
};
</script>
<style></style>
